import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "filter" }
const _hoisted_2 = { class: "filter__text" }
const _hoisted_3 = { class: "filter__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["filter__trigger", {
        'filter__trigger--active': _ctx.isOpenModel,
        'filter__trigger--has-value': _ctx.hasValue,
      }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpenModel = !_ctx.isOpenModel))
    }, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.text), 1),
      _cache[1] || (_cache[1] = _createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, [
        _createElementVNode("path", {
          d: "M20 5H4L10.4 12.3578V17.4444L13.6 19V12.3578L20 5Z",
          "stroke-width": "1.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1))
    ], 2),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 512), [
      [_vShow, _ctx.isOpenModel]
    ])
  ]))
}